import React from 'react';

export default class DpcCardHorizontalImage extends React.Component {

    getText(text){
        if(!text || typeof text !== "string")
            return "";

        const regex = /(( ?)<\/?(?:a)[^>]*>)|<[^>]+>( ?)/ig;
        const subst = `$1`;
        const body = text.replace(regex, subst);

        if(body.length <= 120)
            return body;
        const subString = body.substr(0, 119);
        return subString.substr(0, subString.lastIndexOf(" ")) + "...";
    }

    render(){
        return (
            <div className="col-12 col-md-6">
                <article className="card-wrapper card-space">
                    <div className="card w-100">
                        <div className="row">
                            <div className="col-12 col-xl-4">
                                {this.props.image &&
                                <a href={this.props.slug}>
                                    <img alt={this.props.altImage}
                                         src={this.props.image.localFile?.publicURL}
                                         className="card-img"
                                    />
                                </a>
                                }
                            </div>

                            <div className="col-12 col-xl-8">
                                <div className="card-body">
                                    {this.props.data &&
                                    <div className="category-top">
                                        <span className="data">{this.props.data}</span>
                                    </div>
                                    }
                                    <h3 className="h6 card-title"><a href={this.props.slug}>{this.props.title}</a></h3>
                                    <div className="card-text"
                                         dangerouslySetInnerHTML={{__html: this.getText(this.props.body)}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        )
    }
}
